import LayoutPage from "@/views/shared/LayoutPage"

export default [
    {
        path: '/',
        component: LayoutPage,
        children: [
            {
                path: "",
                name: "home",
                component: () => import("@/views/DashboardPage.vue"),
                meta: { title: "Home", requiresAuth: true },
            },
            {
                path: "/FormPage",
                name: "FormPage",
                component: () => import("@/views/FormPage.vue"),
                meta: {
                    title: "FormPage",
                    titleLocalizationCode: "Form_Page",
                    requiresAuth: true
                },
            },
        ],
    },
    {
        path: "/home",
        redirect: "/"
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'NotFound',
        component: LayoutPage,
        children: [
            {
                path: "",
                name: "errorPage",
                component: () => import("@/views/ErrorPage.vue"),
                meta: {
                    title: "ErrorPage",
                    titleLocalizationCode: "Error_Page",
                    desc: "ErrorPage page",
                    descLocalizationCode: "Error_Page",
                    requiresAuth: true
                },
            },
        ],
    }
]


